module.exports = __webpack_public_path__ + "static/media/financial-stress-and-thinking.48d8f3a1.png";